enum userTypes {
  SET_USER = "SET_USER",
  LOGOUT_USER = "LOGOUT_USER",
  SET_TOKEN = "SET_TOKEN",
  SET_PERMISSIONS = "SET_PERMISSIONS",
}

export default userTypes;
